// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2e6d429a","732":"065ec350","977":"63d4296f"}[chunkId] + ".chunk.js";
};